<template>
	<v-app class="auth-page">
		<v-app-bar :elevation="0"
			color="rgba(255,255,255,.9)"
			app
			absolute
			light
			height="115">
			<v-container id="nav-top" class="py-0 px-7 fill-height" fluid>
				<v-row class="align-center">
					<Link id="logo" :href="route('dashboard')">
						<Logo variant="filled" />
					</Link>

					<v-spacer></v-spacer>

					<a href="https://www.belloldow.com/contact/"
						target="_blank"
						class="v-size--small theme--light text-decoration-none grey--text text--darken-1 text-uppercase">
						Contact Us
					</a>

					<Link :href="route('password.request')"
						class="v-size--small theme--light text-decoration-none grey--text text--darken-1 text-uppercase mx-7">
						Reset Password
					</Link>

					<Link :href="route('login')"
						class="v-size--small theme--light text-decoration-none grey--text text--darken-1 text-uppercase">
						Login
					</Link>
				</v-row>
			</v-container>
		</v-app-bar>
		<div id="auth" class="fill-height">
			<v-layout wrap fill-height justify-center align-content-center>
				<div class="d-block">
					<slot />
				</div>
			</v-layout>
		</div>
	</v-app>
</template>
<script>

export default {
	props: {
		//
	},
	data () {
		return {
			//
		}
	}
}
</script>
